import { queueMacrotask } from 'module/helpers/macrotask';
import { useEffect, useRef } from 'react';

export const useAutoFocusOnTitle = () => {
  const titleRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    queueMacrotask(() => {
      titleRef.current?.select();
    });
  }, []);

  return titleRef;
};
